import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import ReactAvatar from 'react-avatar';

import { useMsgContext } from '../msg-context';
import { useWidgetContext } from 'widget/widget-context';
import { useIsPrimaryDark } from 'widget/hooks';

const Userpic = () => {
  const { widget } = useWidgetContext();
  const { msg } = useMsgContext();

  const { t } = useTranslation();
  const isPrimaryDark = useIsPrimaryDark();

  const { colors } = widget;

  return (
    <div
      className={cn('whatcrm-widget-message__userpic', {
        'whatcrm-widget-message__userpic_dark': !isPrimaryDark,
      })}
    >
      <ReactAvatar
        color={colors.primary}
        name={t`Manager`}
        size="28"
        src={msg.sender_userpic}
      />
    </div>
  );
};

export default Userpic;
